import { NuvoScrollView } from '@nuvolo/nuux-core/components/NuvoScrollView';
import { color } from '@nuvolo/nuux-theme/utils';
import styled from 'styled-components';
import { isDarkTheme } from '#/common/utils/themeDetection';

interface ScrollerProps {
  className?: string;
}

const Scroller = styled(NuvoScrollView).attrs({
  scrollByContent: false,
})<ScrollerProps>`
  &.dx-scrollable > .dx-scrollable-wrapper > .dx-scrollable-container > .dx-scrollable-content {
    display: flex;
    flex-direction: column;
    & > .dx-scrollview-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 0;
    }
  }

  .dx-button.dx-state-focused {
    background-color: ${color('primary', 'light3')};
  }

  /* Default background (data grids/tables) - white */
  background-color: ${color('custom', 'dataGridPageBackground')};

  /* Form type background - beige */
  &.tmm-page-form {
    background-color: ${color('custom', 'formBackground')};
  }

  /* Dashboard type background - transparent only in dark theme to show background image */
  &.tmm-page-dashboard {
    background-color: ${({ theme }) =>
      isDarkTheme(theme) ? 'transparent' : color('custom', 'formBackground')};
  }
`;

export default Scroller;
